console.log('design');

document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll("[data-area]");
    sections.forEach(section => {
        const trigger = section.querySelector("[data-trigger]");
        const boxes = section.querySelectorAll("[data-box]");

        if (!trigger || boxes.length < 2) return;

        let lastY = window.scrollY;
        const showBox = (index) => {
            boxes.forEach((box, i) => {
                box.classList.toggle("show", i === index);
            });
        };

        const onScroll = () => {
            const y = window.scrollY;
            const down = y > lastY;
            lastY = y;
            const triggerTop = trigger.getBoundingClientRect().top;
            const line = window.innerHeight * 0.7; // ← 50vhライン
            const passed = triggerTop <= line;

            if (down) {
                if (passed) showBox(1);
                else showBox(0);
            } else {
                if (!passed) showBox(0);
                else showBox(1);
            }
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
    });
});
